import { Injectable } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';
import { Store, select } from '@ngrx/store';

import { Observable } from 'rxjs';
import {
    acceptSharedAnnualReport,
    declineSharedAnnualReport,
    getNewAnnualReportsSharedWithMe,
    getShareInformation,
    shareAnnualReport,
} from '../actions/annualreport-shares.action';
import { CreateShareDto } from '../dtos/createShare.dto';
import { GetShareDto } from '../dtos/getShare.dto';
import { selectCurrentActiveUserShares } from '../reducer/annual-report-shares.reducer';
import { FeatureState } from '../reducer/annualReport.reducer';
import { IAnnualReportSharesProvider } from './annual-report-shares.provider.interface';
@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class AnnualReportSharesProvider implements IAnnualReportSharesProvider {
    constructor(private store: Store<FeatureState>) {}

    selectSharedAnnualReport$(): Observable<GetShareDto[]> {
        return this.store.pipe(select(selectCurrentActiveUserShares));
    }
    dispatchGetCurrentActiveUserSharedAnnualReports(): void {
        this.store.dispatch(getNewAnnualReportsSharedWithMe.do());
    }
    dispatchAcceptSharedAnnualReport(id: string): void {
        this.store.dispatch(acceptSharedAnnualReport.do({ payload: id }));
    }
    dispatchDeclineSharedAnnualReport(id: string): void {
        this.store.dispatch(declineSharedAnnualReport.do({ payload: id }));
    }

    dispatchShareAnnualReport(shareAnnualReportDto: CreateShareDto): void {
        this.store.dispatch(shareAnnualReport.do({ payload: shareAnnualReportDto }));
    }

    dispatchGetShareInformation(annualReportMetaInfoId: string): void {
        this.store.dispatch(getShareInformation.do({ payload: annualReportMetaInfoId }));
    }
}
